<template>
  <div
    :class="[
      'playlist-assigned-by__wrapper',
      isCardLayout && 'playlist-assigned-by__wrapper--card',
    ]"
  >
    <img
      :src="require('@/assets/images/instructor_fallback.png')"
      :ssrc="avatar"
      alt="Avatar"
      class="playlist-assigned-by__avatar"
    />
    <div class="playlist-assigned-by__info">
      <div class="playlist-assigned-by__name">
        Assigned by <b>{{ assignedByName }}</b>
      </div>
      <span class="playlist-assigned-by__time">{{ timeAgo }}</span>
      <div
        v-if="!isCardLayout && isSonarPlaylist"
        class="playlist-assigned-by__changelog"
        @click="showChangeLogModal(true)"
      >
        See change log
      </div>
    </div>
    <PlaylistChangeLog
      v-if="showChangeLog"
      :playlistName="playlist.name"
      :playlistId="playlist.id"
      @close-dialog-modal="showChangeLogModal(false)"
    />
  </div>
</template>

<script>
import { formatDistanceToNow } from 'date-fns'
import { fetchAvatar } from '@/models/profiles'
import PlaylistChangeLog from '@/components/playlists/PlaylistChangeLog.vue'

export default {
  name: 'PlaylistAssignedBy',
  components: {
    PlaylistChangeLog,
  },
  props: {
    playlist: {
      type: Object,
      required: true,
    },
    isCardLayout: {
      type: Boolean,
      required: false,
      default: true,
    },
    isSonarPlaylist: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      showChangeLog: false,
    }
  },
  computed: {
    assignedByName() {
      const { first_name, last_name } = this.playlist?.assigned_by
      return `${first_name} ${last_name}`
    },
    timeAgo() {
      return formatDistanceToNow(
        new Date(this.playlist.user_status?.started_date),
        {
          addSuffix: true,
        }
      )
    },
    avatar() {
      return this.playlist.assigned_by
        ? fetchAvatar(this.playlist.assigned_by.id)
        : null
    },
  },
  methods: {
    showChangeLogModal(value) {
      this.showChangeLog = value
    },
  },
}
</script>

<style lang="scss" scoped>
.playlist-assigned-by {
  &__wrapper {
    display: flex;
    align-items: flex-start;
    width: fit-content;
    @include tablet {
      width: auto;
    }
    &--card {
      align-items: center;
    }
  }

  &__time {
    color: var(--light-blue-gray);
    &:first-letter {
      text-transform: capitalize;
    }
  }
  &__avatar {
    width: 42px;
    height: 42px;
    border-radius: 50%;
    margin-right: 10px;
  }
  &__info {
    font-size: rem(12);
    line-height: rem(14);
    width: 100%;
    color: var(--white);
    flex: 1 0 fit-content;
    display: flex;
    flex-direction: column;
  }
  &__changelog {
    cursor: pointer;
    color: var(--purple-pale);
  }
}
</style>
